var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoInfomaticaTrasparente(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 351,
    viewBox: "0 0 1000 351",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.6394 190.735H20.3906V292.38H45.6394V190.735Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M131.845 247.984L82.8431 190.735H63.5664V292.38H88.8152V236.617L137.518 292.38H157.094V190.735H131.845V247.984Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M173.34 292.38H198.589V256.504H242.217V234.533H198.589V213.006H249.086V190.735H173.34V292.38Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M313.358 188.642C282.725 188.642 259.57 211.954 259.57 241.558C259.57 271.161 282.725 294.464 313.358 294.464C343.99 294.464 367.29 271.152 367.29 241.558C367.29 211.964 344.125 188.642 313.358 188.642ZM313.358 270.997C296.918 270.997 285.118 257.546 285.118 241.558C285.118 225.569 296.918 212.108 313.358 212.108C329.798 212.108 341.597 225.559 341.597 241.558C341.597 257.556 329.798 270.997 313.358 270.997Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M437.505 244.993L401.354 190.735H382.676V292.38H407.925L407.78 241.104L430.491 276.227V276.381H444.529V276.227L467.086 241.403V292.38H492.344V190.735H473.521L437.505 244.993Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M572.839 183.855L545.642 199.429L541.387 209.445L575.309 190.05L572.839 183.855Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M507.041 292.379H533.93L540.655 274.885H583.675L590.544 292.379H617.288L576.024 194.334L539.391 215.736L507.031 292.379H507.041ZM549.019 253.368L562.17 219.586L575.32 253.368H549.029H549.019Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M618.719 213.305H651.136V292.38H676.385V213.305H708.657V190.735H618.719V213.305Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M746.303 190.735H721.055V292.38H746.303V190.735Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M815.471 212.263C828.911 212.263 837.883 220.185 840.72 232.883H866.567C863.431 206.57 843.411 188.642 815.616 188.642C784.993 188.642 761.828 210.912 761.828 241.558C761.828 272.203 784.993 294.464 815.616 294.464C843.411 294.464 863.431 276.526 866.567 250.223H840.72C837.883 262.93 828.911 270.852 815.471 270.852C798.886 270.852 787.386 258.444 787.386 241.558C787.386 224.672 798.886 212.263 815.471 212.263Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M942.161 190.137H918.108L874.934 292.379H901.832L908.557 274.885H951.587L958.456 292.379H985.2L942.17 190.137H942.161ZM916.912 253.358L930.062 219.576L943.212 253.358H916.922H916.912Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M500.443 140.106C498.33 140.106 496.285 139.006 495.156 137.057C493.468 134.133 494.471 130.399 497.385 128.72L718.439 0.820293C721.363 -0.868309 725.087 0.135203 726.775 3.04925C728.454 5.96329 727.46 9.69752 724.547 11.3861L503.492 139.286C502.537 139.836 501.485 140.106 500.453 140.106H500.443Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M400.31 139.914C398.197 139.914 396.152 138.814 395.023 136.865C393.344 133.941 394.338 130.207 397.252 128.528L562.994 32.6054C565.918 30.9168 569.642 31.9204 571.33 34.8344C573.019 37.7581 572.015 41.4923 569.102 43.1713L403.359 139.094C402.394 139.644 401.352 139.914 400.31 139.914Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M299.949 139.912C297.865 139.912 295.839 138.832 294.72 136.892C293.061 134.007 294.045 130.312 296.929 128.652L408.344 64.3017C411.229 62.6324 414.915 63.6166 416.584 66.5113C418.253 69.3964 417.269 73.0824 414.374 74.7517L302.969 139.102C302.023 139.652 300.982 139.912 299.959 139.912H299.949Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoInfomaticaTrasparente);
export default __webpack_public_path__ + "static/media/LOGO_INFOMATICA_TRASPARENTE.c6c1402500a6a54c4acadc9a590760eb.svg";
export { ForwardRef as ReactComponent };